import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { TRANSLATIONS, AVAILABLE_LANGUAGES } from '@i18n';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

export const LanguageProvider = ({ children }) => {
  const getInitialLanguage = () => {
    if (typeof window === 'undefined') return 'es';
    const saved = localStorage.getItem('torneos-language');
    if (saved && TRANSLATIONS[saved]) return saved;
    // Detect browser language
    const browserLang = navigator.language?.split('-')[0];
    if (browserLang === 'eu') return 'eu';
    if (browserLang === 'en') return 'en';
    return 'es';
  };

  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = useCallback((lang) => {
    if (TRANSLATIONS[lang]) {
      setLanguageState(lang);
      localStorage.setItem('torneos-language', lang);
    }
  }, []);

  const t = useCallback((key) => {
    return TRANSLATIONS[language]?.[key] || TRANSLATIONS.es[key] || key;
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    t,
    languages: AVAILABLE_LANGUAGES
  }), [language, setLanguage, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export default LanguageContext;
